/**
 *  @internal
 *
 *  Used to determine if two arrays include the same values.
 *  No more, no less.
 */
import { forEach } from './index';
export default function arraysMatch(a, b) {
    // First try some things to see if early fail/succeed is possible
    // This is WAY more efficient
    if (a === b) {
        return true;
    }
    if (!Array.isArray(a) || !Array.isArray(b)) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }
    if (!a.length) {
        return true;
    }
    const aSorted = Array.from(a).sort();
    const bSorted = Array.from(b).sort();
    let matches = true;
    forEach(aSorted, (valueA) => {
        if (valueA !== bSorted.shift()) {
            matches = false;
        }
        return matches;
    });
    return matches;
}
//# sourceMappingURL=arraysMatch.js.map